import { render, staticRenderFns } from "./EditHackathonPage.vue?vue&type=template&id=3807a818&scoped=true&"
import script from "./EditHackathonPage.vue?vue&type=script&lang=js&"
export * from "./EditHackathonPage.vue?vue&type=script&lang=js&"
import style0 from "./EditHackathonPage.vue?vue&type=style&index=0&id=3807a818&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3807a818",
  null
  
)

export default component.exports